<template>
  <v-app id="app_overall_tracking_history">
    <v-overlay v-model="loadningScreen" :scrim="false" class="centered-overlay">
      <v-progress-circular
        color="green"
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>

    <v-container fluid>
      <v-row class="pl-2 pr-6">
        <v-col class="mt-3" cols="7">
          <p class="custom_page_main_title">OVERALL HISTORY</p>
          <p class="custom_page_main_sub_title" style="opacity: 0.6">
            Analyse the collection of overall history tracking data based on
            officers.
          </p>
        </v-col>
        <v-col class="px-4 mt-5" cols="5">
          <v-row class="custom_tool_bar_style">
            <v-divider
              :thickness="3"
              class="divider-vertical"
              vertical
            ></v-divider>
            <v-btn
              class="gray-text"
              size="x-large"
              variant="text"
              @click="backPageRoute()"
            >
              <v-icon size="x-large">mdi-menu-left</v-icon>&nbsp;BACK
            </v-btn>
          </v-row>
        </v-col>
      </v-row>

      <v-card
        class="custom_card_box mt-8"
        elevation="1"
        border="sm opacity-1"
        rounded="lg"
      >
        <template v-slot:append>
          <v-card-text class="custom_tool_bar_style">
            <v-btn
              class="custom_pdf_btn"
              variant="outlined"
              @click="isClickedDownloadPDFBtn"
            >
              <v-icon size="large">mdi-file-pdf</v-icon>&nbsp;&nbsp;PDF
            </v-btn>

            <v-btn
              class="custom_excel_btn ml-4"
              variant="outlined"
              @click="isClickedDownloadExcelBtn"
            >
              <v-icon size="large">mdi-file-excel</v-icon>&nbsp;&nbsp;Excel
            </v-btn>
            <!-- <v-btn   class="custom_excel_btn ml-4" variant="outlined" @click="isClickedDownloadExcelBtn">
              <v-icon size="large" color="#2E7D32">mdi-file-excel</v-icon>&nbsp;&nbsp;Excel
            </v-btn> -->
          </v-card-text>
        </template>

        <v-divider thickness="2"></v-divider>

        <v-card-text>
          <v-row class="mt-0">
            <v-col cols="12" md="4">
              <v-date-input
                v-model="dates"
                append-inner-icon="mdi-close"
                prepend-inner-icon="$calendar"
                prepend-icon=""
                label="Select Date Range"
                multiple="range"
                variant="outlined"
                @click:append-inner="clearDateRange"
                density="comfortable"
                class="custom_input_field_color"
              ></v-date-input>
            </v-col>

            <!-- <v-col cols="12" md="4">
              <v-autocomplete
                  v-model="agentTypeList"
                  :items="agentTypeOptions"
                  clearable
                  label="Officer type"
                  placeholder="Select officer type"
                  variant="outlined"
                  item-title="name"
                  item-value="value"
                  density="comfortable"
                  class="custom_input_field_color"
                  multiple
              ></v-autocomplete>
            </v-col> -->
             <v-col cols="12" md="4">
              <v-autocomplete
              v-model="agentList"
              :items="agentOptions"
              clearable
              label="Officer"
              placeholder="Select officer"
              variant="outlined"
              item-title="name"
              item-value="name"
              density="comfortable"
              class="custom_input_field_color"
              multiple
            >
              <template v-slot:item="{ props, item }">
                <v-list-item
                  v-bind="props"
                  :title="item.raw.name"
                  :subtitle="item.raw.registration_num"
                ></v-list-item>
              </template>
            </v-autocomplete>

             </v-col>

            <!-- <v-col cols="12" md="4">
              <v-autocomplete
                  v-model="agentList"
                  :items="agentDataOptions"
                  clearable
                  label="Route"
                  placeholder="Select Route"
                  variant="outlined"
                  item-title="name"
                  item-value="name"
                  density="comfortable"
                  class="custom_input_field_color"
                  multiple
              ></v-autocomplete>
            </v-col> -->

            <v-col cols="12" md="4">
              <v-text-field
                v-model="serachModel"
                label="Search"
                persistent-placeholder
                placeholder="Search"
                variant="outlined"
                density="comfortable"
                class="custom_input_field_color"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
          <v-col cols="12" md="4">
            <v-autocomplete
              v-model="selectedPremiseCode"
              :items="premiseCodeList"
              clearable
              item-title="role_type"
              item-value="id"
              label="Premise Code"
              placeholder="Select Premise Code"
              variant="outlined"
              density="comfortable"
              @update:modelValue="applyFilters"
            />
          </v-col>

          <v-col cols="12" md="4">
            <v-autocomplete
              v-model="selectedDivisionCode"
              :items="divisionCodeList"
              clearable
              item-title="name"
              item-value="id"
              label="Division Code"
              placeholder="Select Division Code"
              variant="outlined"
              density="comfortable"
              @update:modelValue="applyFilters"
            />
          </v-col>

          <!-- <v-col cols="12" md="4">
            <v-autocomplete
              v-model="selectedStatus"
              :items="statusList"
              clearable
              item-title="name"
              item-value="id"
              label="Status"
              placeholder="Select Status"
              variant="outlined"
              density="comfortable"
              @update:modelValue="applyFilters"
            />
          </v-col> -->
        </v-row>

        <!-- <v-row
          class="pa-2 ma-3"
          style="
            background-color: #fff3cd;
            border: 1px solid #566573;
            border-radius: 4px;
          "
        >
          <v-col class="d-flex align-center" cols="12">
            <v-icon color="success" size="small" class="mr-1"
              >mdi-checkbox-blank-circle</v-icon
            >
            <span class="mr-4" style="font-size: 12px; color: #333"
              >APPROVED</span
            >

            <v-icon color="#efac00" size="small" class="mr-1"
              >mdi-checkbox-blank-circle</v-icon
            >
            <span class="mr-4" style="font-size: 12px; color: #333">PENDING</span>

            <v-icon color="error" size="small" class="mr-1"
              >mdi-checkbox-blank-circle</v-icon
            >
            <span style="font-size: 12px; color: #333">REJECTED</span>
          </v-col>
        </v-row> -->


          <v-divider></v-divider>

          <v-data-table
            :headers="headers"
            :items="filteredData"
            :loading="loading"
            :search="serachModel"
            class="custom_table_normal"
          >
            <template v-slot:[`item.agentName`]="{ item }">
              
              <p
                class="text-caption custom_page_main_sub_title font-weight-bold mt-2"
              >
               <!-- <v-icon v-if="item.approvalStatus == 'APPROVED'" color="success" size="small" class="mr-1">mdi-checkbox-blank-circle</v-icon> 
               <v-icon v-if="item.approvalStatus == 'PENDING'" color="#efac00" size="small" class="mr-1">mdi-checkbox-blank-circle</v-icon> 
               <v-icon v-if="item.approvalStatus == 'REJECTED'" color="error" size="small" class="mr-1">mdi-checkbox-blank-circle</v-icon>  -->
               {{ item.agentName }}
              </p>
              <v-divider class="mt-2 mb-2"></v-divider>
              <p
                class="custom_page_main_sub_title_very_small_red text-caption font-weight-medium mb-2"
              >
                {{ item.RegisterNumber != "null" ? item.RegisterNumber : ""}}
              </p>
            </template>

            <template v-slot:[`item.fistAddress`]="{ item }">
              <p
                class="text-caption custom_page_main_sub_title font-weight-bold mt-2"
              >
                {{ item.fistAddress }}
              </p>
              <v-divider class="mt-2 mb-2"></v-divider>
              <!-- <p class="custom_font_color_view text-caption font-weight-medium mb-2">{{ item.statTime }}</p> -->
              <p
                class="custom_font_color_view text-caption font-weight-medium mb-2"
              >
                {{ item.statTime }}
              </p>
            </template>

            <template v-slot:[`item.lastAddress`]="{ item }">
              <p
                class="text-caption custom_page_main_sub_title font-weight-bold mt-2"
              >
                {{ item.lastAddress }}
              </p>
              <v-divider class="mt-2 mb-2"></v-divider>
              <!-- <p class="custom_font_color_view text-caption font-weight-medium mb-2">{{ item.endTime }}</p> -->
              <p
                class="custom_font_color_view text-caption font-weight-medium mb-2"
              >
                {{ item.endTime }}
              </p>
            </template>

            <template v-slot:[`item.actions`]="{ item }">
              <v-menu transition="slide-x-transition" id="app_user_role_list">
                <template v-slot:activator="{ props }">
                  <v-btn
                    class="custom_btn_primary"
                    variant="flat"
                    size="large"
                    v-bind="props"
                  >
                    ACTIONS &nbsp; &nbsp;<v-icon>mdi-menu-down</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item v-if="permissions.read" @click="mapView(item)">
                    <v-list-item-title class="custom_font_color_view"
                      >MAP VIEW</v-list-item-title
                    >
                  </v-list-item>
                  <v-list-item
                    v-if="permissions.delete"
                    @click="confirmDelete(item)"
                  >
                    <v-list-item-title class="custom_font_color_delete"
                      >DELETE</v-list-item-title
                    >
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>

            <template v-slot:bottom>
              <div class="text-center pt-2">
                <v-pagination
                  v-model="page"
                  :length="totalPages"
                  :total-visible="10"
                ></v-pagination>
              </div>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>

      <!--  collection recode edit view component call to dialog box-->
      <v-dialog
        v-model="mapViewDialog"
        fullscreen
        id="app_overall_tracking_history"
      >
        <v-card flat>
          <v-toolbar
            style="border-radius: 0px !important"
            class="custom_fullscreen_dialog_toolbar pr-5 custom_card_box"
            color="white"
            dense
          >
            <v-toolbar-title>
              <v-img
                class="custom_company_logo_nav"
                :src="require('@/img/company_logo/Assetline_logo.png')"
                @click="closeD()"
              ></v-img>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
              class="custom_red_btn"
              variant="flat"
              @click="mapViewDialog = false"
            >
              CLOSE
            </v-btn>
          </v-toolbar>

          <v-row class="mt-15 custom_scroll_option_fullscreen_dialog">
            <v-col cols="12" md="12">
              <v-card
                class="pa-0 mx-6 mt-2 custom_card_box"
                border="sm opacity-1"
              >
                <template v-slot:prepend>
                  <v-icon>mdi-view-dashboard</v-icon>
                  <v-card-title
                    class="font-weight-bold custom_page_main_sub_title ml-3"
                    >MAP VIEW</v-card-title
                  >
                </template>
              </v-card>

              <v-card
                ref="mapElement"
                class="pa-3 mx-6 custom_card_box mt-4"
                border="sm opacity-1"
              >
                <v-row class="ma-0">
                  <v-col cols="12" xs="12" sm="4" md="9" lg="9">
                    <v-row>
                      <v-col cols="12" xs="12" sm="12" md="3" lg="2" xl="2">
                        <!--                        <v-img :src="OfficerDetails.user_image ? `${baseUrl}/SFA/public/${user.OfficerDetails.user_image}` : require('@/assets/ASSETS/PERSONS/person-3.jpg')"-->
                        <!--                               max-width="150" class="user_image_view"></v-img>-->

                        <v-img
                          :src="
                            this.agentImage
                              ? `${baseUrl}/${this.agentImage}`
                              : require('@/assets/ASSETS/PERSONS/person-3.jpg')
                          "
                          max-width="150"
                          class="avatar-image"
                        />
                      </v-col>
                      <v-col cols="5" xs="5" sm="5" md="5" lg="5" xl="5">
                        <v-table density="compact" class="custom_table_normal">
                          <tbody>
                            <tr>
                              <td>
                                <p
                                  class="font-weight-bold custom_page_component_main_title text-body-2"
                                >
                                  Officer Name &nbsp;
                                </p>
                              </td>
                              <td>
                                <p
                                  class="font-weight-bold custom_page_component_main_title text-body-2"
                                  style="color: #01579B !important"
                                >
                                  {{ this.agentName }}
                                </p>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <p
                                  class="font-weight-bold custom_page_component_main_title text-caption"
                                >
                                  Visited Date &nbsp;
                                </p>
                              </td>
                              <td>
                                <p
                                  class="font-weight-medium text-caption custom_page_component_main_title mt-1"
                                  style="color: #01579B !important"
                                >
                                  {{ this.visitedDate }}
                                </p>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <p
                                  class="font-weight-bold custom_page_component_main_title text-caption"
                                >
                                  Start time &nbsp;
                                </p>
                                <p
                                  class="font-weight-medium text-caption custom_page_component_main_title mt-1"
                                  style="color: #01579B !important"
                                >
                                  {{ this.startTime }}
                                </p>
                              </td>
                              <td>
                                <p
                                  class="font-weight-bold custom_page_component_main_title text-caption"
                                >
                                  End time &nbsp;
                                </p>
                                <p
                                  class="font-weight-medium text-caption custom_page_component_main_title mt-1"
                                  style="color: #01579B !important"
                                >
                                  {{ this.endTime }}
                                </p>
                              </td>
                              <!-- <td><p class="font-weight-medium text-caption custom_page_component_main_title mt-1">{{ this.startTime }}</p></td> -->
                            </tr>

                          </tbody>
                        </v-table>

                        <v-table density="compact" class="custom_table_normal mt-2">
                          <tbody>
                            <tr>
                              <td>
                                <p
                                  class="font-weight-bold custom_page_component_main_title text-body-2"
                                  style="color: #01579B !important"
                                >
                                  Justification for route switch
                                </p>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <p
                                  class="font-weight-medium text-caption custom_page_component_main_title mt-1"
                                  v-for="(justifications, index) in RouteSwitchJustifications"
                                  :key="index"
                                >
                                 ● {{ justifications }}
                                </p>
                              </td>
                            </tr>
                          </tbody>
                        </v-table>

                      </v-col>

                      <v-col cols="5" xs="5" sm="5" md="5" lg="5" xl="5">

                        <v-table density="compact" class="custom_table_normal mt-2" style="background-color:#e5ae126b;">
                          <tbody>
                            <tr>
                              <td>
                                <p
                                  class="font-weight-bold custom_page_component_main_title text-body-2"
                                  style="color: #01579B !important"
                                >
                                 <strong> Total Distance &nbsp; </strong>
                                </p>
                              </td>
                              <td>
                                <p
                                  class="font-weight-bold custom_page_component_main_title text-body-2"
                                  style="color: #01579B !important"
                                >
                                 <strong>  {{ this.totalDistance }} </strong>
                                </p>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <p
                                  class="font-weight-bold custom_page_component_main_title text-caption"
                                >
                                  Official Route Distance &nbsp;
                                </p>
                              </td>
                              <td>
                                <p
                                  class="font-weight-medium text-caption custom_page_component_main_title mt-1"
                                >
                                  {{ this.officialDistance }}
                                </p>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <p
                                  class="font-weight-bold custom_page_component_main_title text-caption"
                                >
                                  Personal Route Distance &nbsp;
                                </p>
                              </td>
                              <td>
                                <p
                                  class="font-weight-medium text-caption custom_page_component_main_title mt-1"
                                >
                                  {{ this.personalDistance }}
                                </p>
                              </td>
                            </tr>
                           
                          </tbody>
                        </v-table>
                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col cols="12" xs="12" sm="3" md="3" lg="3">
                    <v-row class="text-right mt-3 mr-3">
                      <v-spacer></v-spacer>
                      <v-btn
                        class="custom_btn_primary"
                        size="large"
                        variant="outlined"
                        v-if="showDownloadButton"
                        @click="downloadPdf"
                        >Download PDF</v-btn
                      >
                      <!-- <v-btn
                      class="ml-2"
                        size="large"
                        variant="outlined"
                        v-if="showDownloadButton"
                        @click="openApprovalDialogWindow"
                        >Action</v-btn> -->
                    </v-row>
                  </v-col>

                  <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                    <v-divider></v-divider>
                  </v-col>
                </v-row>

                <v-row class="px-3">
                  <v-col cols="12" xs="12" sm="12" md="8" lg="9">
                    <GMapMap
                      :center="center"
                      :zoom="6.5"
                      class="rounded-lg custom_card_box d-flex overall_tracking_map mb-3"
                    >
                      <GMapPolyline
                        :options="polylineOptions"
                        :path="pathCoordinates"
                      />

                      <!-- Start Point Marker -->
                      <GMapMarker
                        :icon="startIcon"
                        :position="startPoint"
                        :title="'Start Point'"
                      />

                      <!-- End Point Marker -->
                      <GMapMarker
                        :icon="endIcon"
                        :position="endPoint"
                        :title="'End Point'"
                      />
                    </GMapMap>
                  </v-col>

                  <v-col cols="12" xs="12" sm="12" md="4" lg="3">
                    <div class="mt-1">
                      <v-divider class="mt-1 mb-4"></v-divider>
                      <p
                        class="custom_page_component_main_title text-body-1 font-weight-bold text-uppercase"
                      >
                        JOURNEY DETAILS
                      </p>
                      <v-divider class="mt-4 mb-4"></v-divider>
                      <p
                        class="custom_page_main_sub_title_very_small_red text-body-2 font-weight-medium"
                      >
                        Officer Name: &nbsp;
                        <strong>{{ this.agentName }}</strong>
                      </p>
                      <v-divider class="mt-4 mb-4"></v-divider>

                      <v-card
                        class="custom_card_box"
                        elevation="0"
                        border="sm opacity-1"
                        rounded="md"
                      >
                        <template v-slot:prepend>
                          <v-avatar color="#F5D9D9" class="mb-6">
                            <v-icon
                              color="#BB0000"
                              icon="mdi-location-enter"
                            ></v-icon>
                          </v-avatar>
                        </template>
                        <template v-slot:item>
                          <div class="text-body-2 font-weight-bold mt-3 ml-4">
                            {{ startLocation }}
                          </div>
                          <v-divider class="mb-2 mt-2"></v-divider>
                          <div class="d-flex ml-4">
                            <div
                              class="custom_page_main_sub_title_very_small_red text-body-2 font-weight-medium mt-1"
                            >
                              {{ firstOutlet.created_at }}
                            </div>
                            <v-divider vertical class="mr-2 ml-2"></v-divider>
                            <div>
                              <v-chip
                                class="custom_green_chip"
                                size="small"
                                variant="outlined"
                                >Start Location</v-chip
                              >
                            </div>
                          </div>
                        </template>
                      </v-card>
                      <v-card
                        class="custom_card_box mt-3"
                        elevation="0"
                        border="sm opacity-1"
                        rounded="md"
                      >
                        <template v-slot:prepend>
                          <v-avatar color="#F5D9D9" class="mb-6">
                            <v-icon
                              color="#BB0000"
                              icon="mdi-location-exit"
                            ></v-icon>
                          </v-avatar>
                        </template>
                        <template v-slot:item>
                          <div class="text-body-2 font-weight-bold mt-3 ml-4">
                            {{ endLocation }}
                          </div>

                          <v-divider class="mb-2 mt-2"></v-divider>
                          <div class="d-flex ml-4">
                            <div
                              class="custom_page_main_sub_title_very_small_red text-body-2 font-weight-medium mt-1"
                            >
                              {{ secondOutlet.created_at }}
                            </div>
                            <v-divider vertical class="mr-2 ml-2"></v-divider>
                            <div>
                              <v-chip
                                class="custom_red_chip"
                                size="small"
                                variant="outlined"
                                >End Location</v-chip
                              >
                            </div>
                          </div>
                        </template>
                      </v-card>
                    </div>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-dialog>
      <!--  collection recode edit view component call to dialog box-->

      <!-- Dialog Box for Approval Route -->

      <v-dialog
          v-model="routeApprovalDialog"
          max-height="700"
          id="app_lead_list"
          max-width="900"
        >
          <v-card rounded="md">
            <div class="pa-4">
              <v-card color="#F0F0F0" flat>
                <template v-slot:prepend>
                  <v-card-title class="text-subtitle-1 font-weight-bold">
                    APPROVE REQUEST
                  </v-card-title>
                </template>
                <v-spacer></v-spacer>
                <template v-slot:append>
                  <v-btn
                    @click="routeApprovalDialog = false"
                    icon="mdi-close"
                    size="x-small"
                  ></v-btn>
                </template>
              </v-card>

              <!-- Form Content -->
              <v-card-text>
                <v-form ref="form">
                        <v-radio-group v-model="selectedCatagoryOption" inline>
                          <v-radio :label="'Official Route Distance - (' + officialDistance +')'" value="officialDistance" style="width: 50%;"></v-radio>
                          <v-radio :label="'Official Route Distance (Manual Entry) - (' + officialRouteDistanceManually + ' km)'" value="officialDistanceManually" style="width: 50%;"></v-radio>
                        </v-radio-group>
                  <v-textarea
                    v-model="remarkOfApproval"
                    label="Message"
                    placeholder="Enter your message"
                  ></v-textarea>
                </v-form>
              </v-card-text>

              <!-- Action Buttons -->
              <v-card-actions class="d-flex justify-end">
                <v-btn
                  style="
                    width: 30% !important;
                    background-color: #e6effc !important;
                    border: 1px solid #0000ff !important;
                    color: #0000ff !important;
                  "
                  variant="outlined"
                  @click="approveRequest('APPROVED')"
                >
                  APPROVE
                </v-btn>
                <v-btn
                  style="
                    width: 30% !important;
                    background-color: #fdecea !important;
                    border: 1px solid #f44336 !important;
                    color: #f44336 !important;
                  "
                  variant="outlined"
                  @click="approveRequest('REJECTED')"
                >
                  REJECT
                </v-btn>
              </v-card-actions>
            </div>
          </v-card>
        </v-dialog>

        <v-dialog
        v-model="rejectApprovedDialog"
        max-height="700"
        id="app_lead_list"
        max-width="600"
      >
        <v-card rounded="md">
          <div class="pa-4">
            <v-card color="#F0F0F0" flat>
              <template v-slot:prepend>
                <v-card-title class="text-subtitle-1 font-weight-bold">
                  REJECT REQUEST
                </v-card-title>
              </template>
              <v-spacer></v-spacer>
              <template v-slot:append>
                <v-btn
                  @click="rejectApprovedDialog = false"
                  icon="mdi-close"
                  size="x-small"
                ></v-btn>
              </template>
            </v-card>

            <!-- Form Content -->
            <v-card-text>
              <v-form ref="form">
                <v-textarea autocomplete="Message" label="Message" v-model="rejectReason" :counter="maxChars"
                            :maxlength="maxChars"></v-textarea>
              </v-form>
            </v-card-text>

            <!-- Action Buttons -->
            <v-card-actions class="d-flex justify-end">
              <v-btn
                style="
                  width: 30% !important;
                  background-color: #fdecea !important;
                  border: 1px solid #f44336 !important;
                  color: #f44336 !important;
                "
                variant="outlined"
                @click="rejectRequest"
              >
                REJECT
              </v-btn>
            </v-card-actions>
          </div>
        </v-card>
      </v-dialog>


      <!-- Delete User confirmation dialog -->
      <v-dialog
        v-model="deleteDialog"
        id="app_overall_tracking_history"
        max-height="500"
        max-width="500"
        persistent
      >
        <v-card rounded="md">
          <div class="pa-4">
            <v-card color="#F0F0F0" flat>
              <template v-slot:prepend>
                <v-card-title class="text-subtitle-1 font-weight-bold"
                  >DELETE TRACKING DATA</v-card-title
                >
              </template>
              <v-spacer></v-spacer>
              <template v-slot:append>
                <v-btn
                  @click="deleteDialog = false"
                  icon="mdi-close"
                  size="x-small"
                ></v-btn>
              </template>
            </v-card>

            <!-- <v-card color="white" flat class="mt-3">
              <v-card-item>
                <v-card-title style="color: #BB0000" class="text-body-1 font-weight-medium">
                  <v-icon color="warning" size="small">mdi-alert</v-icon>
                  &nbsp;&nbsp;Do you want to delete this tracking record ?
                </v-card-title>

                <p style="opacity: 0.7;" class="text-body-2 mt-4 text-justify">
                  This overall tracking record will be deleted immediately. Once deleted, it can no longer be used for any purpose.
                </p>

                <v-divider class="mt-4"></v-divider>

                <div class="float-end mt-4 ">
                  <v-btn  class="custom_btn_primary" @click="deleteItem">DELETE</v-btn>
                  <v-btn  class="ml-3 custom_btn_secondary" @click="deleteDialog = false">CANCEL</v-btn>
                </div>
              </v-card-item>
            </v-card> -->

            <v-card color="white" flat class="mt-3">
              <v-card-item>
                <v-card-title
                  style="color: #bb0000"
                  class="text-body-1 font-weight-medium"
                >
                  <v-icon color="warning" size="small">mdi-alert</v-icon>
                  &nbsp;&nbsp;Do you want to delete this tracking record ?
                </v-card-title>

                <p style="opacity: 0.7" class="text-body-2 mt-4 text-justify">
                  This tracking record will be deleted immediately. Once
                  deleted, it can no longer be used for any purpose.
                  <!-- <span style="color: blue">
                      Further, these modules are also related to the following
                      other modules also, so please read and confirm before deleting this.
                    </span> -->
                </p>

                <v-divider class="mt-4"></v-divider>

                <div class="float-end mt-4">
                  <v-btn
                    style="
                      width: 35% !important;
                      background-color: #fdecea !important;
                      border: 1px solid #f44336 !important;
                      color: #f44336 !important;
                    "
                    variant="outlined"
                    @click="deleteItem"
                    :loading="deleteLoading"
                  >
                    DELETE
                  </v-btn>
                  <v-btn
                    class="ml-3 custom_btn_secondary"
                    @click="deleteDialog = false"
                    >CANCEL</v-btn
                  >
                </div>
              </v-card-item>
            </v-card>
          </div>
        </v-card>
      </v-dialog>
      <v-snackbar
        v-model="snackAlert.snackbar"
        :color="snackAlert.snackColor"
        :right="snackAlert.snackBarRight"
        :top="snackAlert.snackBarTop"
        timeout="3000"
      >
        {{ snackAlert.snackMessage }}
      </v-snackbar>
    </v-container>
  </v-app>
</template>
<script>
import index from "vuex";
import axios from "axios";
import jsPDF from "jspdf";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import html2canvas from "html2canvas";
import { getPermissions } from "@/plugins/permissions";

export default {
  data() {
    return {
      agentOptions: [],
      agentTypeList: [], // For officer type filter
      agentTypeOptions: [], // Will store officer type options
      page: 1,
      totalPages: 0,
      loading: false,
      loadningScreen: false,
      startLocation: "",
      endLocation: "",
      deleteAgentId: "",
      showDownloadButton: true,
      deleteDate: "",
      startTime: "",
      snackAlert: {
        snackbar: false, // Snackbar visibility
        snackColor: "", // Snackbar color
        snackMessage: "", // Snackbar message
        snackBarRight: false, // Snackbar position right
        snackBarTop: true, // Snackbar position top
      },
       divisionCodeList:[],
      selectedDivisionCode:null,
      premiseCodeList:[],
      selectedPremiseCode:null,
      statusList:['ALL','APPROVED','PENDING','REJECTED'],
      selectedStatus:null,
      endTime: "",
      agentImage: "",
      visitedDate: "",
      agentName: "",
      RouteSwitchJustifications:[],
      personalDistanceManualEntry:"",
      agentDataOptions: [],
      dates: [],
      serachModel: "",
      firstOutlet: "",
      secondOutlet: "",
      baseUrl: "",
      search: " ",
      deleteDialog: false,
      itemToDelete: null,
      deletedDate: "",
      deletedType: "",
      routeId: "",
      mapViewDialog: false,
      isDownloadedExcel: false,
      isDownloadedPDF: false,

      routeApprovalDialog:false,
      rejectApprovedDialog:false,
      remarkOfApproval:"",
      selectedAgentID:"",
      selectedCatagoryOption:null,

      headers: [
        { text: "OFFICER NAME", value: "agentName", title: "OFFICER NAME" },
        {
          text: "START LOCATION",
          value: "fistAddress",
          title: "START LOCATION",
        },
        { text: "END LOCATION", value: "lastAddress", title: "END LOCATION" },
        {
          text: "TOTAL DISTANCE",
          value: "totalDistance",
          title: "TOTAL DISTANCE",
        },
        {
          text: "OFFICER CATEGORY",
          value: "officerCategory",
          title: "OFFICER CATEGORY",
        },
        { text: "DATE", value: "date", title: "DATE" },
        { text: "Action", value: "actions", sortable: false, title: "ACTION" },
      ],
      trackingData: [],
      totalDistance: "",
      trackingHistary: [],
      OfficerDetails: {
        user_image: null,
      },
      center: { lat: 7.375783804167988, lng: 80.63752981355924 },
      pathCoordinates: [{ lat: "", lng: "" }],
      polylineOptions: {
        strokeColor: "#FF0000",
        strokeOpacity: 1.0,
        strokeWeight: 3,
      },
      startPoint: "",
      endPoint: "",
      startIcon: {
        url: "https://maps.google.com/mapfiles/ms/icons/green-dot.png",
      },
      endIcon: {
        url: "https://maps.google.com/mapfiles/ms/icons/red-dot.png",
      },
      agentList: [],
      agents: [
        {
          location: "Mawaramandiya",
          lastUpdated: "30 seconds ago",
          locAddress: "bla blaa blaaaaa",
          locationType: "startLocation",
          trips: [
            { id: 1, destination: "Keells - Edmonton", time: "09:16 AM" },
            { id: 2, destination: "Keells - Kohuwala", time: "10:30 AM" },
          ],
        },
      ],
      mapCenter: { lat: 6.023129913557325, lng: 80.79783798218944 },
      permissions: {},
    };
  },

  watch: {
    agentList: {
      handler() {
        this.getAllTracking(this.page);
      },
    },

    dates: {
      handler() {
        this.getAllTracking(this.page);
      },
    },

    serachModel: {
      handler() {
        this.getAllTracking(this.page);
      },
    },

    selectedPremiseCode: {
      handler() {
        this.getAllTracking(this.page);
      },
    },

    selectedDivisionCode: {
      handler() {
        this.getAllTracking(this.page);
      },
    },

    selectedStatus: {
      handler() {
        this.getAllTracking(this.page);
      },
    },

    page(newVal, oldVal) {
      // if (newVal <= 0) {
      //   this.page = 1;
      //   return;
      // }
      console.log("Current page click", newVal, oldVal);
      this.getAllTracking(newVal);
    },
  },

  computed: {
    index() {
      return index;
    },

    totalDistanceInKm() {
      if (!this.totalDistance) return 0;

      const match = this.totalDistance.match(/^([\d.]+)\s*(km|m)$/i);
      if (!match) return 0;

      const value = parseFloat(match[1]);
      const unit = match[2].toLowerCase();

      return unit === 'm' ? value / 1000 : value;
    },

    officialRouteDistanceManually() {
      const personalKm = parseFloat(this.personalDistanceManualEntry) || 0;
      return (this.totalDistanceInKm - personalKm).toFixed(2); // 2 decimal places
    },

     agentOptionsFromTable() {
    const uniqueAgents = new Map();
    this.trackingData.forEach(item => {
      if (item.agentName && !uniqueAgents.has(item.agentName)) {
        uniqueAgents.set(item.agentName, {
          name: item.agentName,
          regNum: item.RegisterNumber
        });
      }
    });
    return Array.from(uniqueAgents.values());
  },


    // filteredData() {
    //   let filtered = this.trackingData;

    //   // Apply search filter
    //   filtered = filtered.filter((item) =>
    //     item.agentName.toLowerCase().includes(this.serachModel.toLowerCase()) ||
    //     item.RegisterNumber.toLowerCase().includes(this.serachModel.toLowerCase()) ||
    //     item.date.toLowerCase().includes(this.serachModel.toLowerCase()) ||
    //     item.statTime.toLowerCase().includes(this.serachModel.toLowerCase()) ||
    //     item.lastAddress.toLowerCase().includes(this.serachModel.toLowerCase())
    //   );

    //   // Filter by selected agents
    //   if (Array.isArray(this.agentList) && this.agentList.length > 0) {
    //     filtered = filtered.filter((item) =>
    //       this.agentList.includes(item.agentName)
    //     );
    //   }

    //   // Calculate total (official + personal) distance from lat/lng
    //   filtered = filtered.map((item) => {
    //     const officialPoints = (item.OverRollTrackingDetails || []).filter(
    //       (point) => point.work_type === "official"
    //     );
    //     const personalPoints = (item.OverRollTrackingDetails || []).filter(
    //       (point) => point.work_type === "personal"
    //     );

    //     const officialDistance = this.calculatePathDistance(officialPoints);
    //     const personalDistance = this.calculatePathDistance(personalPoints);

    //     const totalDistance = officialDistance + personalDistance;

    //     const distanceFormatted = `${totalDistance.toFixed(3)} km`;

    //     return {
    //       ...item,
    //       totalDistance: distanceFormatted,
    //     };
    //   });

    //   return filtered;
    // },

    filteredData() {
      let filtered = this.trackingData;

      //search filter
      filtered = filtered.filter((item) =>
        item.agentName.toLowerCase().includes(this.serachModel.toLowerCase()) ||
        item.RegisterNumber.toLowerCase().includes(this.serachModel.toLowerCase()) ||
        item.date.toLowerCase().includes(this.serachModel.toLowerCase()) ||
        item.statTime.toLowerCase().includes(this.serachModel.toLowerCase()) ||
        item.lastAddress.toLowerCase().includes(this.serachModel.toLowerCase())
      );

      //agents filter
      if (Array.isArray(this.agentList) && this.agentList.length > 0) {
        filtered = filtered.filter((item) =>
          this.agentList.includes(item.agentName)
        );
      }

      // Calculate distances per item 
      filtered = filtered.map((item) => {
        const d = this.calcDistancesByRuns(item.OverRollTrackingDetails || []);

        return {
          ...item,
          totalDistance: `${d.total.toFixed(3)} km`,
          officialDistance: `${d.official.toFixed(3)} km`,
          personalDistance: `${d.personal.toFixed(3)} km`,
        };
      });

  return filtered;
}




  },

  mounted() {
    const dashboardId = 7;
    this.permissions = getPermissions(dashboardId);

    this.getAllTracking(this.page);
    this.fetchAllAgents();
    this.getBaseUrl();
  },

  methods: {
    backPageRoute() {
      // this.$router.push('/dashboard');
      this.$router.go(-1);
    },

    getBaseUrl() {
      this.baseUrl = `${process.env.VUE_APP_IMAGE_PUBLIC_URL}`;
    },

    openApprovalDialogWindow(){
      this.routeApprovalDialog = true;
    },

    calculatePathDistance(points) {
      let distance = 0;
      for (let i = 0; i < points.length - 1; i++) {
        const p1 = points[i];
        const p2 = points[i + 1];
        distance += this.calculateDistance(
          parseFloat(p1.lat || p1.latitude),
          parseFloat(p1.lng || p1.longitude),
          parseFloat(p2.lat || p2.latitude),
          parseFloat(p2.lng || p2.longitude)
        );
      }
      return distance;
    },

    approveRequest(status){
      const userId = localStorage.getItem('userId');
      const token = localStorage.getItem('token');

      const valueOfManualOfficialDistance = this.officialRouteDistanceManually;

      this.loadningScreen = true;

      axios.post(`api/overRollTrackingApprovalRequest`, {
        userId: this.selectedAgentID,
        proceedBy: userId,
        startTime: this.startTime,
        endTime: this.endTime,
        date: this.visitedDate,
        remark: this.remarkOfApproval,
        officialDistance: this.officialDistance,
        officialDistanceManually: valueOfManualOfficialDistance + ' km',
        personalDistance: this.personalDistance,
        personalDistanceManualEntry: this.personalDistanceManualEntry,
        radioBtnValue: this.selectedCatagoryOption,
        status: status,

      }, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      })
      .then(response => {

        if (response.data.success) {
        this.loadningScreen = false;
        this.routeApprovalDialog = false;
        this.mapViewDialog = false;

        this.remarkOfApproval = "";

        if(status == "APPROVED"){
          this.showSnackbar("Request was approved successfully!", "success");
        }
        if(status == "REJECTED"){
          this.showSnackbar("Request was rejected successfully!", "success");
        }

        

        this.getAllTracking(this.page);
        }

      })
      .catch(error => {
        console.error('Error fetching data:', error);
        this.loadningScreen = false;
      });
    },

    // mirrors backend grouping and boundary rule
    calcDistancesByRuns(points = []) {
      const norm = (t) => String(t ?? '').trim().toLowerCase();
      const pts = (points || []).filter(p => p && p.lat != null && p.lng != null);
      if (pts.length < 2) return { official: 0, personal: 0, total: 0 };

      let total = 0, official = 0, personal = 0;
      let prev = pts[0];
      let currType = norm(prev.work_type);

      for (let i = 1; i < pts.length; i++) {
        const curr = pts[i];
        const segKm = this.calculateDistance(
          parseFloat(prev.lat || prev.latitude),
          parseFloat(prev.lng || prev.longitude),
          parseFloat(curr.lat || curr.latitude),
          parseFloat(curr.lng || curr.longitude)
        );

        const t = norm(curr.work_type);

        // Assign boundary segment to the *new* type (same as backend)
        const ownerType = (t === currType) ? currType : t;

        if (ownerType === 'official') official += segKm;
        else                          personal += segKm;

        total += segKm;
        currType = t;
        prev = curr;
      }

      return {
        official: Number(official.toFixed(3)),
        personal: Number(personal.toFixed(3)),
        total:    Number(total.toFixed(3)),
      };
    },

    calculateDistance(lat1, lon1, lat2, lon2) {
      const toRad = (value) => (value * Math.PI) / 180;
      const R = 6371; // Radius of Earth in km

      const dLat = toRad(lat2 - lat1);
      const dLon = toRad(lon2 - lon1);

      const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(toRad(lat1)) *
          Math.cos(toRad(lat2)) *
          Math.sin(dLon / 2) *
          Math.sin(dLon / 2);

      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      return R * c; // Distance in km
    },

    


    downloadPdf() {
      this.showDownloadButton = false;
      this.$nextTick(() => {
        const mapElement = this.$refs.mapElement?.$el || this.$refs.mapElement;
        if (mapElement instanceof HTMLElement) {
          html2canvas(mapElement, {
            useCORS: true,
            logging: true,
            scale: 2,
          })
            .then((canvas) => {
              const imgData = canvas.toDataURL("image/png");
              const pdf = new jsPDF({
                orientation: "landscape",
                unit: "pt",
                format: [canvas.width, canvas.height],
              });

              // Add the captured image to the PDF
              pdf.addImage(imgData, "PNG", 0, 0, canvas.width, canvas.height);

              // Save the PDF
              pdf.save("overall History.pdf");

              this.showDownloadButton = true;
            })
            .catch((error) => {
              console.error("Error capturing the map:", error);
              this.showDownloadButton = true;
            });
        } else {
          console.error("Map element is not attached or is not a valid node.");
          this.showDownloadButton = true;
        }
      });
    },

    clearDateRange() {
      this.dates = [];
    },

    exportPDF() {
      const doc = new jsPDF();
      // Set the title for the document
      doc.text("Overall Tracking report", 14, 10);

      // Prepare the data for the table
      const tableData = this.filteredData.map((item, index) => [
        index + 1,
        item.agentName,
        item.RegisterNumber,
        item.fistAddress,
        item.statTime,
        item.lastAddress,
        item.endTime,
        item.totalDistance,
        item.date,
      ]);
      // Define the columns for the table
      const tableColumns = [
        "#",
        "OFFICER NAME",
        "OFFICER NUMBER",
        "START LOCATION",
        "START TIME",
        "END LOCATION",
        "END TIME",
        "TOTAL DISTANCE",
        "DATE",
      ];

      // AutoTable plugin to create a table
      doc.autoTable({
        head: [tableColumns],
        body: tableData,
      });
      this.isDownloadedPDF = false;
      // Save the PDF with a name
      doc.save("Overall tracking History.pdf");
    },

    exportExcel() {
      const tableData = this.filteredData.map((item) => ({
        // '#': index + 1,
        "OFFICER NAME": item.agentName,
        "OFFICER NUMBER": item.RegisterNumber,
        "START LOCATION": item.fistAddress,
        "START TIME": item.statTime,
        "END LOCATION": item.lastAddress,
        "END TIME": item.endTime,
        "TOTAL DISTANCE": item.totalDistance,
        " DATE": item.date,
      }));

      const worksheet = XLSX.utils.json_to_sheet(tableData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Tracking");
      this.isDownloadedExcel = false;
      XLSX.writeFile(workbook, "Overall tracking History.xlsx");
    },

    isClickedDownloadExcelBtn() {
      this.isDownloadedExcel = true;
      this.getAllTracking(this.page);
    },

    isClickedDownloadPDFBtn() {
      this.isDownloadedPDF = true;
      this.getAllTracking(this.page);
    },

    // Get All Tracing Historay
    getAllTracking(page) {
    const userId = localStorage.getItem('userId');
    const token = localStorage.getItem('token');

    this.loading = true;

    axios.post(`api/overrolltrackingHistory?page=${page}`, {
      userId: userId,
      agentList: this.agentList,
      agentTypeList: this.agentTypeList,
      dates: this.dates,
      search: this.serachModel,
      selectedPremiseCode: this.selectedPremiseCode,
      selectedDivisionCode: this.selectedDivisionCode,
      selectedStatus: this.selectedStatus,
      is_downloaded: this.isDownloadedExcel,
      is_downloaded_pdf: this.isDownloadedPDF,
    }, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    })
    .then(response => {
      this.trackingData = response.data.data;
      this.agentOptions = response.data.officerList;
      this.divisionCodeList = response.data.divisionCode;
      this.premiseCodeList = response.data.premiseCode;
      this.totalPages = response.data.pagination?.last_page || 1;
      this.page = response.data.pagination?.current_page || 1;
      this.loading = false;

      // Update agent options whenever new data is fetched
      // this.agentOptions = this.agentOptionsFromTable;

      if (this.isDownloadedExcel) {
        this.exportExcel();
        this.submitPdfExcelLog("pdf");
      }

      if (this.isDownloadedPDF) {
        this.exportPDF();
        this.submitPdfExcelLog("Excel");
      }

      this.isDownloadedExcel = false;
      this.isDownloadedPDF = false;
    })
    .catch(error => {
      console.error('Error fetching data:', error);
      this.loading = false;
      this.isDownloadedExcel = false;
      this.isDownloadedPDF = false;
    });
  },

  submitPdfExcelLog(Type){

       const userId = localStorage.getItem('userId');
      const token = localStorage.getItem('token');
      const type = Type;

        axios.post(
        `${process.env.VUE_APP_API_BASE_URL}api/submit-pdfand-excel-log`,
        { userId: userId, type: type },
        { 
            headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
            }
        }
        )
    },

    getOutletDeteails(firstId, lastId) {
      const userId = localStorage.getItem("userId");
      const token = localStorage.getItem("token");

      axios
        .post(
          `api/getOutletDetails`,
          {
            userId: userId,
            firstId: firstId,
            lastId: lastId,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          this.firstOutlet = response.data.first;
          this.secondOutlet = response.data.first;
        })
        .catch((error) => {
          console.error("Error fetching Agents:", error);
        });
    },    

    // With SmapTORoad
    async mapView(item) {
    
    this.mapViewDialog = true;
    this.startLocation = item.fistAddress;
    this.endLocation = item.lastAddress;
    this.agentName = item.agentName;
    this.selectedAgentID = item.agentId;
    this.RouteSwitchJustifications = item.routeSwitchJustifications;
    this.personalDistanceManualEntry = item.personalDistanceManualEntry;
    this.visitedDate = item.date;
    this.startTime = item.statTime;
    this.endTime = item.endTime;
    this.agentImage = item.agentImage;

    if (item.OverRollTrackingDetails.length > 0) {
      
      // 🔹 Snap main route path only
      this.pathCoordinates = await this.snapToRoadsFromTracking(item.OverRollTrackingDetails);

      if (this.pathCoordinates.length > 0) {
        this.mapCenter = this.pathCoordinates[0];
        this.startPoint = this.pathCoordinates[0];
        this.endPoint = this.pathCoordinates[this.pathCoordinates.length - 1];
      }

      
      this.officialDistance = item.officialDistance || "0 Km";
      this.personalDistance = item.personalDistance || "0 Km";

      
      this.totalDistance = item.totalDistance || "0 Km";

      
    }
  },

    // WIthOut snapToRoads
    // async mapView(item) {
    //   this.mapViewDialog = true;
    //   this.startLocation = item.fistAddress;
    //   this.endLocation = item.lastAddress;
    //   this.agentName = item.agentName;
    //   this.selectedAgentID = item.agentId;
    //   this.RouteSwitchJustifications = item.routeSwitchJustifications;
    //   this.personalDistanceManualEntry = item.personalDistanceManualEntry;
    //   this.visitedDate = item.date;
    //   this.startTime = item.statTime;
    //   this.endTime = item.endTime;
    //   this.agentImage = item.agentImage;

    //   if (item.OverRollTrackingDetails.length > 0) {
    //     const officialTracking = item.OverRollTrackingDetails.filter(
    //       (point) => point.work_type === "official"
    //     );
    //     const personalTracking = item.OverRollTrackingDetails.filter(
    //       (point) => point.work_type === "personal"
    //     );

    //     // Convert to valid lat/lng format for Google Maps
    //     this.pathCoordinates = item.OverRollTrackingDetails.map((point) => ({
    //       lat: parseFloat(point.lat || point.latitude),
    //       lng: parseFloat(point.lng || point.longitude),
    //     }));

    //     // Set map center and start/end points
    //     this.mapCenter = {
    //       lat: this.pathCoordinates[0].lat,
    //       lng: this.pathCoordinates[0].lng,
    //     };

    //     this.startPoint = this.pathCoordinates[0];
    //     this.endPoint = this.pathCoordinates[this.pathCoordinates.length - 1];

    //     // Calculate total distance
    //     // const distance = this.calculateTotalDistance(this.pathCoordinates);
    //     // this.totalDistance = distance < 1
    //     //     ? `${(distance * 1000).toFixed(0)} m`
    //     //     : `${distance.toFixed(2)} Km`;

    //     const officialCoordinates = officialTracking.map((point) => ({
    //       lat: parseFloat(point.lat || point.latitude),
    //       lng: parseFloat(point.lng || point.longitude),
    //     }));

    //     const personalCoordinates = personalTracking.map((point) => ({
    //       lat: parseFloat(point.lat || point.latitude),
    //       lng: parseFloat(point.lng || point.longitude),
    //     }));

    //     // 🔹 Calculate total distances
    //     const officialDistance =
    //       this.calculateTotalDistance(officialCoordinates);
    //     const personalDistance =
    //       this.calculateTotalDistance(personalCoordinates);

    //     // 🔹 Format distance display
    //     this.officialDistance =
    //       officialDistance < 1
    //         ? `${(officialDistance * 1000).toFixed(0)} m`
    //         : `${officialDistance.toFixed(2)} Km`;

    //     this.personalDistance =
    //       personalDistance < 1
    //         ? `${(personalDistance * 1000).toFixed(0)} m`
    //         : `${personalDistance.toFixed(2)} Km`;

    //     this.totalDistance =
    //       officialDistance + personalDistance < 1
    //         ? `${((officialDistance + personalDistance) * 1000).toFixed(0)} m`
    //         : `${(officialDistance + personalDistance).toFixed(2)} Km`;
    //   }
    // },

      async snapToRoadsFromTracking(details) {
      const apiKey = "AIzaSyCLxo_DWBcGYOuRGfEasgSyTM-y1Wks9FY"; // Replace with your API key

      const coords = details
        .map((point) => {
          const lat = parseFloat(point.lat || point.latitude);
          const lng = parseFloat(point.lng || point.longitude);
          return !isNaN(lat) && !isNaN(lng) ? `${lat},${lng}` : null;
        })
        .filter((coord) => coord !== null);

      if (coords.length === 0) return [];

      const batchSize = 100;
      const snappedAll = [];

      for (let i = 0; i < coords.length; i += batchSize) {
        const batchPath = coords.slice(i, i + batchSize).join("|");
        const url = `https://roads.googleapis.com/v1/snapToRoads?path=${batchPath}&interpolate=true&key=${apiKey}`;

        try {
          const response = await fetch(url);
          const data = await response.json();

          if (data.snappedPoints) {
            const batchSnapped = data.snappedPoints.map((p) => ({
              lat: p.location.latitude,
              lng: p.location.longitude,
            }));
            snappedAll.push(...batchSnapped);
          }
        } catch (error) {
          console.error("Snap to Roads API error:", error);
        }
      }

      return snappedAll;
    },

    // Function to calculate total distance between the path coordinates using Haversine formula
    calculateTotalDistance(pathCoordinates) {
      // Function to convert degrees to radians
      const toRadians = (deg) => deg * (Math.PI / 180);

      // Haversine formula
      const haversineDistance = (lat1, lng1, lat2, lng2) => {
        const R = 6371; // Radius of the Earth in kilometers
        const dLat = toRadians(lat2 - lat1);
        const dLng = toRadians(lng2 - lng1);

        const a =
          Math.sin(dLat / 2) * Math.sin(dLat / 2) +
          Math.cos(toRadians(lat1)) *
            Math.cos(toRadians(lat2)) *
            Math.sin(dLng / 2) *
            Math.sin(dLng / 2);

        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        const distance = R * c;
        return distance;
      };

      let totalDistance = 0;
      // Loop through pathCoordinates and sum the distance between consecutive points
      for (let i = 0; i < pathCoordinates.length - 1; i++) {
        const point1 = pathCoordinates[i];
        const point2 = pathCoordinates[i + 1];

        totalDistance += haversineDistance(
          point1.lat,
          point1.lng,
          point2.lat,
          point2.lng
        );
      }
      return totalDistance;
    },

    closeD() {
      this.mapViewDialog = false;
    },

    confirmDelete(item) {
      this.deleteAgentId = item.agentId;
      this.deleteDate = item.date;
      this.deleteDialog = true;
    },

    deleteItem() {
      this.loadningScreen = true;
      const userId = localStorage.getItem("userId");
      const token = localStorage.getItem("token");

      axios
        .post(
          `api/deletOverRollTrackingDetails`,
          {
            userId: userId,
            agentId: this.deleteAgentId,
            date: this.deleteDate,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          this.deleteDialog = false;
          this.getAllTracking(this.page);
          console.log("deleted", response.data);
          this.loadningScreen = false;
          this.showSnackbar("History delete successfully!", "success");
        })
        .catch((error) => {
          this.loadningScreen = false;
          console.error("Error fetching Agents:", error);
        });
    },

    showSnackbar(message, color) {
      this.snackAlert.snackbar = true;
      this.snackAlert.snackMessage = message;
      this.snackAlert.snackColor = color;
    },

    fetchAllAgents() {
      const userId = localStorage.getItem("userId");
      const token = localStorage.getItem("token");

      axios
        .post(
          `${process.env.VUE_APP_API_BASE_URL}api/agentUser`,
          { userId },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          this.agentDataOptions = response.data.data.map((agent) => ({
            id: agent.id,
            name: agent.name,
            regNum: agent.registration_num,
            type: agent.type || "default", // Assuming there's a type field
          }));

          // Extract unique officer types for filter
          const types = [
            ...new Set(
              response.data.data.map((agent) => agent.type || "default")
            ),
          ];
          this.agentTypeOptions = types.map((type) => ({
            name: type,
            value: type,
          }));

          console.log("Agent Options:", this.agentDataOptions);
          console.log("Agent Type Options:", this.agentTypeOptions);
        })
        .catch((error) => {
          console.error("Error fetching agents:", error);
        });
    },
  },
};
</script>


<style>
@import "../../styles/tracking_management/overall_tracking_history.scss";
</style>